import { useDataQuery } from "@hooks/useData/useDataQuery";
import { selectData } from "@utils/serverClient";
import { Playlist } from "types";

export const usePublicPlaylists = () => {
  const {
    status: playlistsFetchStatus,
    data: playlists = [],
    refetch: getPlaylists,
  } = useDataQuery({
    queryKey: ["publicPlaylists"],
    queryFn: async () => {
      const { data, error } = await selectData({
        table: "playlists",
        columns: "*",
      })
        .is("org_id", null)
        .order("created_at", { ascending: false });
      if (error || !data) return;
      return data;
    },
  });

  const getPlaylistNameById = (id: string): string => {
    const _loc = playlists.find((playlist) => playlist.id === id);
    return _loc?.name ?? "N/A";
  };

  return {
    playlists: playlists as Playlist[],
    playlistsFetchStatus,
    getPlaylists,
    getPlaylistNameById,
  };
};
